import React, { useState } from 'react';
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { isOtherStoriesBrand } from "@pb/utils/brandConfig";
import { isArketBrand } from "@pb/utils/brandConfig";
import { isMonkiBrand } from "@pb/utils/brandConfig";
import { isCosBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import RadioButtonInput from "../../ui/Fields/RadioButtonInput";
import RatingStars from "../../ui/RatingStars";
import BodyText from "../../ui/Typography/texts/BodyText";
import MetaText from "../../ui/Typography/texts/MetaText";
import HeadingLarge from "../../ui/Typography/titles/HeadingLarge";
import HeadingMedium from "../../ui/Typography/titles/HeadingMedium";
import PreHeading from "../../ui/Typography/titles/PreHeading";
import { LIMIT_DAYS_TO_REVIEW } from './constants';
import styles from './ProductReviewCard.module.scss';
const renderRatingRadioList = (rating, sku, handleRatingClick, list, reverseOrder) => {
    if (list.length > 0) {
        const radioButtons = list.map((value) => {
            const isOptionSelected = value.rating === Number(rating);
            const ratingLabel = value.label.split(' ');
            let capitalizedLabel = '';
            if (ratingLabel.length > 1) {
                capitalizedLabel = `${ratingLabel[0].charAt(0).toUpperCase()}${ratingLabel[0]
                    .slice(1)
                    .toLowerCase()} ${ratingLabel.slice(1).join(' ').toLowerCase()}`;
            }
            else {
                capitalizedLabel = ratingLabel[0].toLowerCase();
                capitalizedLabel = `${capitalizedLabel.charAt(0).toUpperCase()}${capitalizedLabel.slice(1)}`;
            }
            const label = `${value.rating}. ${capitalizedLabel}`;
            return (React.createElement(RadioButtonInput, { id: `radio-${sku}${value.rating}`, key: `radio-${sku}${value.rating}`, inputValue: value.rating, name: value.label, label: label, isRadioButtonIconLeft: true, onChange: handleRatingClick, checked: isOptionSelected, className: styles.radioButtonField, isRadioButtonFill: isCosBrand ? 'small' : 'normal' }));
        });
        return (reverseOrder && radioButtons.reverse()) || radioButtons;
    }
    return null;
};
const getProductColorAndSizeAttributes = (list, isMetaStyle) => {
    if (list.length > 0) {
        let colorAndSize = '';
        const color = list.find((item) => item.type === 'color');
        if (color) {
            colorAndSize += color.values[0].valueLabel.toString();
        }
        const size = list.find((item) => item.type === 'size');
        if (size) {
            colorAndSize += ` ${size.typeLabel}${isCosBrand ? ',' : ''} ${size.values[0].valueLabel.toString()}`;
        }
        return (React.createElement(React.Fragment, null, isArketBrand ? (React.createElement(PreHeading, { className: styles.productAttributes }, colorAndSize)) : (React.createElement(BodyText, { className: isCosBrand ? styles.productColourSize : styles.purchaseInformation, meta: !!isMetaStyle }, colorAndSize))));
    }
    return null;
};
const ProductReviewCard = ({ style, className, classes = {}, catalogItem, handleSelectProductToReview, disabled = false, }) => {
    var _a, _b, _c, _d;
    const [rating, setRating] = useState(0);
    const handleRatingClick = (value) => {
        setRating(+value);
        if (handleSelectProductToReview)
            handleSelectProductToReview(catalogItem.sku, value);
    };
    let ratingStarSize;
    switch (true) {
        case isOtherStoriesBrand:
            ratingStarSize = 'normal';
            break;
        case isArketBrand:
            ratingStarSize = 'normal';
            break;
        case isMonkiBrand:
            ratingStarSize = 'large';
            break;
        default:
            ratingStarSize = 'small';
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { style: style, className: cn(styles.productReviewCard, className, classes.root, isArketBrand && styles.articleBorder) },
            React.createElement("figure", { className: styles.productImageContainer },
                React.createElement("img", { src: catalogItem.imageUrl, alt: catalogItem.title })),
            React.createElement("div", { className: styles.productDetail },
                isOtherStoriesBrand || isCosBrand ? (React.createElement(React.Fragment, null,
                    React.createElement(MetaText, { Tag: "h2", className: cn(isCosBrand && disabled && styles.disabled) }, catalogItem.title),
                    getProductColorAndSizeAttributes(catalogItem.attributes, isCosBrand))) : isArketBrand ? (React.createElement(React.Fragment, null,
                    React.createElement(HeadingMedium, { className: styles.productHeader, Tag: "h3" }, catalogItem.title),
                    getProductColorAndSizeAttributes(catalogItem.attributes, false))) : (React.createElement(React.Fragment, null,
                    React.createElement(HeadingLarge, { Tag: "h2" }, catalogItem.title),
                    getProductColorAndSizeAttributes(catalogItem.attributes, false))),
                !isCosBrand && (React.createElement("div", { className: isArketBrand ? styles.ratingStarsContainer : styles.rating, id: catalogItem.sku.toString() },
                    React.createElement(RatingStars, { rating: rating, className: isArketBrand ? styles.ratingStarsSpan : styles.ratingStars, iconSize: ratingStarSize, handleRatingStarOnClick: handleRatingClick }))),
                isCosBrand && disabled && (React.createElement(React.Fragment, null,
                    React.createElement(BodyText, { Tag: "span", className: cn(styles.satisfiedText, styles.disabled), meta: true }, getLabelFromStorage('profile.unreviewedproducts.old.purchase.title')),
                    React.createElement(BodyText, { Tag: "span", className: cn(styles.disabled), meta: true }, ` ${getLabelFromStorage('profile.unreviewedproducts.old.purchase.message').replace('{0}', `${LIMIT_DAYS_TO_REVIEW}`)}`))),
                !isOtherStoriesBrand && !disabled && (React.createElement(BodyText, { className: cn(isArketBrand && styles.ratingText, isCosBrand && styles.satisfiedText), meta: isCosBrand }, getLabelFromStorage('profile.unreviewedproducts.review.page.satisfied'))),
                isCosBrand &&
                    !disabled &&
                    renderRatingRadioList(rating, catalogItem.sku, handleRatingClick, (_d = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.turnTo) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.ratingLabels, isCosBrand)))));
};
export default ProductReviewCard;
//# sourceMappingURL=ProductReviewCard.js.map